import { MessageCircle } from "lucide-react";
import { CONTATO } from "../data/cabanas";

export const Footer = () => (
  <footer className="bg-[#1b4332] py-10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col items-center gap-4 text-center">
      <img
        src="/logo.jpg"
        alt="Vila Gramado"
        className="h-16 w-16 rounded-full object-cover ring-2 ring-[#d4a373]"
      />
      <p className="text-[#f5f0eb] font-bold tracking-wide">VILA GRAMADO — Experience in Nature</p>
      <p className="text-[#f5f0eb]/60 text-xs max-w-md">{CONTATO.endereco}</p>
      <p className="text-[#f5f0eb]/60 text-xs">CNPJ: {CONTATO.cnpj}</p>
    </div>
    <a
      href={`https://wa.me/${CONTATO.whatsappLink}?text=${encodeURIComponent(
        "Olá! Gostaria de informações sobre a Vila Gramado."
      )}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#1eb857] text-white flex items-center justify-center shadow-2xl transition-all duration-300 hover:scale-110"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  </footer>
);
